import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'activeStatus'
})

@Injectable()
export class ActiveStatusPipe implements PipeTransform {

  transform(items: any[], field: string, value): any[] {
    if (value === null || value === '') {
      return items;
    }
    return items.filter(it => it[field] === value);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/activeStatus.pipe.ts